export const coursesData = [
    {
        title: "Clasificación de Imágenes con Redes Neuronales",
        image: "",
        description: "Curso completo sobre clasificación de imágenes utilizando redes neuronales. Incluye clases teóricas y ayudantías prácticas con ejemplos en Python.",
        link: "https://www.youtube.com/playlist?list=PLrPU64ess7Lnsubim9zmeEMBFDOKXgHoC",
        extraLink: "https://www.youtube.com/playlist?list=PLrPU64ess7LkA_mjagctCKDLTu7w9lcfH"
    },
    {
        title: "Álgebra Lineal Aplicada I",
        image: "./calculo.svg",
        description: "Curso fundamental de álgebra lineal con aplicaciones prácticas en ciencia de datos e ingeniería.",
        link: "https://www.youtube.com/watch?v=Es_VktQyIJ8&list=PLrPU64ess7LnUsC5kVieN6QVZKJoIXnAk"
    },
    {
        title: "Cálculo Integral",
        image: "./algebra.svg",
        description: "Curso completo de cálculo integral con aplicaciones en análisis matemático y modelado.",
        link:  "https://www.youtube.com/watch?v=MBFxzhUbJCI&list=PLrPU64ess7LneOacR-KYgBh3wW3A4FYun"
    },
    
]